import { z } from 'zod';
import { LIMITS } from './project.js';
/**
 * Director creativo: desarrolla una idea breve en un brief profesional antes
 * de generar la estructura. Es una ayuda a la creación, no un paso del
 * workflow: el usuario decide si lo usa.
 */
export const BRIEF_THEMES = {
    viajes: 'Viajes y destinos',
    gastronomia: 'Gastronomía y recetas',
    educacion: 'Educación y divulgación',
    tecnologia: 'Tecnología y producto',
    naturaleza: 'Naturaleza y ciencia',
    historia: 'Historia y cultura',
    bienestar: 'Salud y bienestar',
    empresa: 'Empresa y marca',
    inmobiliaria: 'Inmobiliaria y arquitectura',
    eventos: 'Eventos y celebraciones',
    moda: 'Moda y estilo de vida',
    deporte: 'Deporte y aventura',
    arte: 'Arte y creatividad',
    infantil: 'Infantil y familiar',
    documental: 'Documental y testimonio',
    otro: 'Otra temática',
};
export const briefThemeSchema = z.enum(Object.keys(BRIEF_THEMES));
export const BRIEF_NOTES_MAX_LENGTH = 2_000;
export const briefRequestSchema = z.object({
    theme: briefThemeSchema,
    /** Matices del usuario: público, mensaje, lo que no puede faltar. */
    notes: z.string().trim().max(BRIEF_NOTES_MAX_LENGTH).default(''),
});
export const CREATIVE_BRIEF_SCHEMA_VERSION = 1;
/** Salida del Director creativo. Es lo que valida el worker y muestra la interfaz. */
export const creativeBriefSchema = z.object({
    schemaVersion: z.literal(CREATIVE_BRIEF_SCHEMA_VERSION),
    title: z.string().min(1).max(LIMITS.nameMaxLength),
    logline: z.string().min(1).max(300),
    concept: z.string().min(1).max(2_000),
    audience: z.string().min(1).max(500),
    tone: z.string().min(1).max(500),
    visualStyle: z.string().min(1).max(LIMITS.styleMaxLength),
    musicDirection: z.string().min(1).max(LIMITS.musicPromptMaxLength),
    narrationDirection: z.string().max(1_000),
    outline: z
        .array(z.object({
        title: z.string().min(1).max(LIMITS.sceneTitleMaxLength),
        description: z.string().min(1).max(1_000),
    }))
        .min(3)
        .max(12),
    /** La idea ya desarrollada, lista para ser la descripción del proyecto. */
    developedIdea: z.string().min(1).max(LIMITS.descriptionMaxLength),
});
export const briefStatusSchema = z.object({
    status: z.enum(['NONE', 'PENDING', 'RUNNING', 'COMPLETED', 'FAILED', 'CANCELLED']),
    jobId: z.string().uuid().nullable(),
    request: briefRequestSchema.nullable(),
    brief: creativeBriefSchema.nullable(),
    error: z.string().nullable(),
    createdAt: z.string().nullable(),
});
//# sourceMappingURL=brief.js.map